// An admission's department is resolved from its Consultant, and that resolution can
// fail — the doctor's department is free text and may match no medical department. A
// failed resolution must read as an explicit, fixable state rather than an empty cell,
// or the patient quietly disappears from department reports with nothing to explain why.
//
// The id fallback exists because department_id is an opaque "<slug>_<facility_id>" key:
// showing it is ugly but honest, and only happens if the backend returned an id whose
// name it could not look up.
export function departmentLabel(departmentName, departmentId) {
  const name = String(departmentName || "").trim();
  if (name) return name;
  const id = String(departmentId || "").trim();
  if (id) return id;
  return "Department unassigned";
}
